import React from 'react';
import { FiCode, FiLayers, FiCpu, FiAward } from 'react-icons/fi';

function About() {
    const personalHighlights = [
        {
            icon: <FiCode />,
            title: "Cross-Platform Mobile",
            desc: "Experienced in building smooth, responsive mobile applications with Flutter & Dart, focusing on clean UI and seamless API integrations."
        },
        {
            icon: <FiCpu />,
            title: "Backend & AI Solutions",
            desc: "Building lightweight REST APIs using Python & FastAPI, with hands-on experience integrating AI APIs to create smart applications."
        },
        {
            icon: <FiLayers />,
            title: "Clean Architecture",
            desc: "Strict focus on maintainable codebase structures using MVVM architecture, Provider state management, and clear separation of concerns."
        },
        {
            icon: <FiAward />,
            title: "Production Ready",
            desc: "Proven track record of taking products from concept to store release, including app architecture, security, and deployment."
        }
    ];

    return (
        <div className="container">
            <div className="section-card about-card-panel">
                {/* Header */}
                <div className="about-header">
                    <span className="about-tag">Get to know me</span>
                    <h2 className="about-main-title">A bit about myself</h2>
                    <p className="about-intro">
                        I'm a Flutter Developer with hands-on experience building cross-platform mobile
                        applications using Flutter, Firebase, and REST APIs. I specialize in Provider state
                        management and MVVM architecture to deliver clean, scalable app designs. Alongside
                        mobile development, I build backend systems with FastAPI and integrate AI APIs to build
                        intelligent products.
                    </p>
                </div>

                {/* Personal Grid */}
                <div className="capabilities-grid">
                    {personalHighlights.map((item, idx) => (
                        <div key={idx} className="capability-card">
                            <div className="capability-icon">{item.icon}</div>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>

                {/* Practical Summary Bar replacing the generic quote */}
                <div className="about-footer-bar">
                    <p className="about-quote">
                        BS in Computer Science • Specialized in Flutter, FastAPI & AI Integrations
                    </p>
                </div>
            </div>
        </div>
    );
}

export default About;